import Wizard, { WizardStep } from '@cimpress-technology/ff-react-components/lib/Wizard';
import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import GetStartedStep from './GetStartedStep/GetStartedStep';
import AddProductsStep from './AddProductsStep/AddProductsStep';
import SetupPricingTermStep from './SetupPricingTermStep/SetupPricingTermStep';
import SetupShippingPricingTermStep from './SetupShippingPricingTermStep/SetupShippingPricingTermStep';
import ReviewPage from './ReviewPage/ReviewPage';
import styled, { css } from 'react-emotion';
import { selectors as identitySelectors } from '../../../reducers/identities';
import { selectors as configSelectors } from '../../../reducers/configurations';

const START_STEP = 'start';
const PRODUCT_STEP = 'product';
const PRODUCT_PRICING_STEP = 'pricing';
const SHIPPING_PRICING_STEP = 'shipping';
const REVIEW_STEP = 'review';

export const DEFAULT_FLOW = {
  initiator: null,
  acceptors: [],
  productPricingTerm: {},
  shippingPricingTerm: {},
  selectedSkus: {},
  createSuccessful: false,
  shouldHaveGracePeriod: false,
  gracePeriodApprovalDays: 7
};

const wizardBodyStyle = css`
  background-color: #fff;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  padding: 30px 30px 30px;
`;

const wizardStepperStyle = css`
  padding: 0 70px;
`;

const WizardContainer = styled('div')({
  '& > .wizard > .wizard__body': wizardBodyStyle,
  '& > .wizard > .wizard__stepper': wizardStepperStyle
});

class ContractCreatePage extends PureComponent {
  static defaultProps = {};

  static propTypes = {};

  state = {
    active: START_STEP,
    latest: START_STEP,
    flow: DEFAULT_FLOW
  };

  resetProgress = flow => {
    this.setState({ active: START_STEP, latest: START_STEP, flow: flow || DEFAULT_FLOW });
  };

  onChangeFlow = (newFlow, callback = null) => {
    const prevFlow = this.state.flow;

    const updatedFlow = { flow: { ...prevFlow, ...newFlow } };
    return this.setState(updatedFlow, callback);
  };

  onChangeStep = (active, latest, previous, next) => {
    return this.setState({ active, latest });
  };

  onUnload = event => {
    const { createSuccessful } = this.state.flow;
    // only show the leave warning if not successful and not in the result screen
    if (!createSuccessful) {
      event.returnValue = this.props.t('createContract:messages.createUnsuccessfulMessage');
    }
  };

  componentDidMount() {
    window.addEventListener('beforeunload', this.onUnload);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.onUnload);
  }

  render() {
    const { flow, active, latest } = this.state;
    const { t, isShippingCostsEnabled } = this.props;

    return (
      <WizardContainer>
        <Wizard active={active} latest={latest} hideStepper={flow.createSuccessful} onChangeStep={this.onChangeStep}>
          <WizardStep name={START_STEP} title={t('createContract:getStarted.sellerTitle')}>
            <GetStartedStep flow={flow} onChange={this.onChangeFlow} resetProgress={this.resetProgress} />
          </WizardStep>
          <WizardStep name={PRODUCT_STEP} title={t('createContract:addProducts.title')}>
            <AddProductsStep flow={flow} onChange={this.onChangeFlow} />
          </WizardStep>
          <WizardStep name={PRODUCT_PRICING_STEP} title={t('createContract:pricingContract.title')}>
            <SetupPricingTermStep flow={flow} onChange={this.onChangeFlow} />
          </WizardStep>
          {isShippingCostsEnabled && (
            <WizardStep name={SHIPPING_PRICING_STEP} title={t('createContract:shippingContract.title')}>
              <SetupShippingPricingTermStep flow={flow} onChange={this.onChangeFlow} />
            </WizardStep>
          )}
          <WizardStep name={REVIEW_STEP} title={t('createContract:review.title')}>
            <ReviewPage flow={flow} onChange={this.onChangeFlow} />
          </WizardStep>
        </Wizard>
      </WizardContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    userHasAuthorizedFulfillers: identitySelectors.getHasFulfillerIdentities(state),
    isShippingCostsEnabled: configSelectors.getIsShippingCostsEnabled(state)
  };
}

export default withTranslation()(connect(mapStateToProps)(ContractCreatePage));
